import {
    Badge,
    Table,
    Text,
} from "@chakra-ui/react";

import DataTable from "../../../components/DataTable";

const columns = [
    {
        key: "driver",
        label: "Driver",
    },
    {
        key: "status",
        label: "Status",
    },
    {
        key: "milestone",
        label: "Current Milestone",
    },
    {
        key: "deliveries",
        label: "Deliveries",
    },
    {
        key: "earnings",
        label: "Earnings",
        align: "end",
    },
];

const statusColor = {
    Approved: "green",
    Pending: "orange",
    Active: "blue",
    Suspended: "red",
    Rejected: "red",
};

const TopRecruitsTable = ({
    drivers = [],
    milestones = [],
}) => {
    const data =
        drivers
            .filter(
                driver =>
                    driver.driver
                        ?.driver_id
            )
            .map(
                driver => {
                    const driverId =
                        driver.driver
                            ?.driver_id;

                    const driverMilestones =
                        milestones.filter(
                            milestone =>
                                milestone.driver_id ===
                                driverId
                        );

                    const achievedMilestones =
                        driverMilestones.filter(
                            milestone =>
                                milestone.milestone_status ===
                                "Achieved"
                        );

                    const latestMilestone =
                        achievedMilestones[
                            achievedMilestones.length -
                                1
                        ];

                    const totalCommission =
                        achievedMilestones.reduce(
                            (
                                sum,
                                milestone
                            ) =>
                                sum +
                                Number(
                                    milestone.commission_amount ||
                                        0
                                ),
                            0
                        );

                    return {
                        id:
                            driverId,

                        driver:
                            [
                                driver.first_name,
                                driver.last_name,
                            ]
                                .filter(
                                    Boolean
                                )
                                .join(
                                    " "
                                ) ||
                            driver.username ||
                            "Unknown Driver",

                        status:
                            driver.driver
                                ?.status ||
                            "Pending",

                        milestone:
                            latestMilestone
                                ?.milestone_type ||
                            "Registration Started",

                        deliveries:
                            latestMilestone
                                ?.required_value ||
                            0,

                        earnings:
                            totalCommission,
                    };
                }
            )
            .sort(
                (
                    a,
                    b
                ) =>
                    b.earnings -
                    a.earnings
            )
            .slice(
                0,
                5
            );

    return (
        <DataTable
            title="Top Recruits"
            total={
                data.length
            }
            data={data}
            columns={columns}
            pageSize={5}
            filters={[]}
            renderRow={(
                recruit
            ) => (
                <Table.Row
                    key={
                        recruit.id
                    }
                >
                    <Table.Cell>
                        <Text
                            fontWeight="600"
                        >
                            {
                                recruit.driver
                            }
                        </Text>
                    </Table.Cell>

                    <Table.Cell>
                        <Badge
                            colorPalette={
                                statusColor[
                                    recruit
                                        .status
                                ] ||
                                "gray"
                            }
                            borderRadius="full"
                            px={3}
                        >
                            {
                                recruit.status
                            }
                        </Badge>
                    </Table.Cell>

                    <Table.Cell>
                        {
                            recruit.milestone
                        }
                    </Table.Cell>

                    <Table.Cell>
                        {
                            recruit.deliveries
                        }
                    </Table.Cell>

                    <Table.Cell textAlign="end">
                        <Text
                            fontWeight="700"
                            color="#0F766E"
                        >
                            P
                            {recruit.earnings.toFixed(
                                2
                            )}
                        </Text>
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default TopRecruitsTable;